module.exports = __webpack_public_path__ + "fd6dd5fa10c5a74f0a767eeb695342f1.svg";